/**
 * Estilos reutilizáveis para componentes de comparação
 */

// Estilo base para bolinha de período
export const periodDotStyle = (size = 8, showBorder = true, showShadow = true) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    border: showBorder ? '1px solid #fff' : 'none',
    boxShadow: showShadow ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
    display: 'inline-block',
    flexShrink: 0
});

// Estilo para container de período com bolinha
export const periodWithDotContainerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    marginRight: '8px'
};

// Estilo para tooltip de gráficos
export const tooltipStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '6px',
    padding: '12px 16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '13px'
};

// Estilo para título do tooltip
export const tooltipTitleStyle = {
    margin: '0 0 8px 0',
    fontWeight: '600',
    color: '#262626',
    fontSize: '14px'
};

// Estilo para valor do tooltip
export const tooltipValueStyle = {
    margin: '0 0 4px 0',
    fontWeight: '700',
    color: '#262626',
    fontSize: '24px',
    lineHeight: '1.2'
};

// Estilo para container de gráfico
export const chartContainerStyle = {
    width: '100%',
    height: '100%'
};

// Estilo para item de legenda
export const legendItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    color: '#595959'
};

// Estilo para linha de separação em legendas
export const legendSeparatorStyle = {
    margin: '0 4px',
    color: '#d9d9d9'
};
